import React from 'react';

import UnauthorizedIcon from '../../../../assets/icons/unauthorized.svg';
import { UNAUTHORIZED_DESCRIPTION } from '../helpers/constants';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';
import { Paths } from '../../../../shared/paths';

const UnauthorizedPage = () => {
  const onClick = () => {
    window.location.href = Paths.signIn;
  };

  return (
    <CommonErrorPage
      errorImage={UnauthorizedIcon}
      title="Just to be safe, we logged you out"
      description={UNAUTHORIZED_DESCRIPTION}
      onClick={onClick}
      buttonText="Log in"
    />
  );
};

export default UnauthorizedPage;
